export const S3url = 'https://dualappbucket211930-dev.s3.us-east-2.amazonaws.com/public/'

//http://192.168.1.247:5000/
